<template>
	<v-slide-group ref="slideGroup" class="fade-slide-group" :class="{ 'fade-slide-group--start': slideGroup?.hasPrev, 'fade-slide-group--end': slideGroup?.hasNext }" show-arrows="never" @wheel="onWheel">
		<template #default="scope">
			<slot v-bind="scope" />
		</template>
	</v-slide-group>
</template>

<script setup>
import { ref } from 'vue';

const slideGroup = ref(null);

const onWheel = (event) => {
	if (event.shiftKey || Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;
	const delta = event.deltaMode === WheelEvent.DOM_DELTA_LINE ? event.deltaY * 16 : event.deltaY;
	if ((delta < 0 && !slideGroup.value?.hasPrev) || (delta > 0 && !slideGroup.value?.hasNext)) return;
	event.preventDefault();
	event.currentTarget.querySelector('.v-slide-group__container').scrollLeft += delta;
};
</script>
